if (!customElements.get('hs-shipping-offer')) {
  customElements.define('hs-shipping-offer', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('[data-copy-code]');
      if (!button || this.copyHandler || !navigator.clipboard?.writeText) return;

      button.hidden = false;
      this.copyHandler = async () => {
        const label = button.querySelector('[data-copy-label]');
        const status = this.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(button.dataset.copyCode);
          label.textContent = 'Code kopiert';
          status.textContent = 'HEAVENSHIP kopiert. Füge den Code im Checkout ein.';
        } catch {
          label.textContent = 'HEAVENSHIP';
          status.textContent = 'Bitte gib HEAVENSHIP im Rabattcode-Feld im Checkout ein.';
        }
      };
      button.addEventListener('click', this.copyHandler);
    }

    disconnectedCallback() {
      this.querySelector('[data-copy-code]')?.removeEventListener('click', this.copyHandler);
      this.copyHandler = null;
    }
  });
}
